import { Show } from "@clerk/react";
import { Navigate } from "react-router-dom";

export default function AuthLayout({ children }) {
  return (
    <div className="min-h-screen flex bg-background" data-testid="auth-page">
      <aside className="hidden lg:flex w-[44%] flex-col justify-between border-r border-border bg-card p-12">
        <div className="font-display text-sm tracking-[0.3em] uppercase text-muted-foreground">The White Project Co.</div>
        <div className="rise">
          <h1 className="font-display text-5xl font-semibold tracking-tight leading-[1.05]">
            Financial<br />Records
          </h1>
          <p className="mt-6 max-w-sm text-muted-foreground">
            Shared books for Yash, Pranay and Nemik. Every figure exact to the cent, every change on the record.
          </p>
        </div>
        <div className="font-mono text-xs text-muted-foreground">AUD · FY 1 Jul – 30 Jun</div>
      </aside>
      <main className="flex-1 flex items-center justify-center p-6">
        <Show when="signed-in"><Navigate to="/setup" replace /></Show>
        <Show when="signed-out">{children}</Show>
      </main>
    </div>
  );
}
